import { createIdStatusHelpers } from "~/utils/statusLookup";
const helpers = createIdStatusHelpers({
    classPrefix: "admin-lead-status",
    byId: {
        "0": { label: "Pending", slug: "pending" },
        "1": { label: "Sent", slug: "sent" },
        "2": { label: "Rejected", slug: "rejected" },
        "3": { label: "Hold", slug: "hold" },
    },
});
export function getAdminLeadStatusMeta(value) {
    return helpers.getMeta(value);
}
export function getAdminLeadStatusOption(flag) {
    return helpers.getOption(flag);
}
